const { aemUrl, aemConfig } = window.__conf__;

const getMethod = 'GET';

export const getAEMContent = async (productID) => {
    try {
        const aemID = aemConfig[productID];
        const response = await fetch(
            `${aemUrl}/en-us/apply/usbank/${aemID}/product-recommender.model.json`,
            { method: getMethod },
        );
        return response.json();
    } catch (err) {
        throw new Error(err);
    }
};
